import styled, { css, DefaultTheme } from "styled-components";
import { theme } from "../../constants/StyledComponents";

type StyledBodyTypProps = {
  $noLineHeight?: boolean;
  $variant?: string;
  $color?: string;
  $maxWidth?: number;
};

/* variants */

const variantStyles = (theme: DefaultTheme, variant = "2") =>
  ({
    1: css`
      font-size: ${theme.variables.fs_16};
    `,
    2: css`
      font-size: ${theme.variables.fs_14};
    `,
    3: css`
      font-size: ${theme.variables.fs_12};
    `,
  })[variant];

const StyledBodyTyp = styled.span<StyledBodyTypProps>`
  ${({ theme, $variant: variant }) => variantStyles(theme, variant)}
  color: ${({ $color: color }) => color ?? theme.colors.black};
  display: flex;
  flex-direction: row;
  align-items: center;
  line-height: ${({ $noLineHeight }) => ($noLineHeight ? "100%" : "1.6")};

  ${({ $maxWidth }) =>
    $maxWidth
      ? css`
          width: ${$maxWidth}px;
          display: block;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        `
      : null}
`;

export { StyledBodyTyp };
